import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/pages/Layout/Layout'

import Morpheus from '@/pages/Morpheus/Morpheus'

import Chat from '@/pages/Morpheus/Chat'

Vue.use(Router)

let router = new Router({
  routes: [{
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: '/morpheus/chat',
    children: [{
      path: '/morpheus',
      name: 'Morpheus',
      component: Morpheus,
      redirect: '/morpheus/chat',
      children: [{
        path: 'chat',
        name: 'Chat',
        component: Chat
      }]
    }]
  }]
})
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js